import * as React from 'react'
import '../styles/App.scss'
import '../styles/JobCategory.scss'

import Button from '@material-ui/core/Button'
import { JobCategories } from '../types/jobCategories'
import { JobCategoryNames } from '../constants/jobCategoryNames'
import images from '../images'

import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface JobCategoryProps {
  onSelectJobCategory: (name: string, id: string) => void
  setJobCategoryName: (event: any) => void
  onSetSelectedJobCategory: (selectedJobCategory: string) => void
  jobCategories: JobCategories[]
  selectedJobCategory: string
  disabled: boolean
}

interface JobCategoryState {
  selectedCategory: string,
  disabled: boolean
}

export default class JobCategory extends React.Component<JobCategoryProps, JobCategoryState> {
  constructor(props: JobCategoryProps) {
    super(props)
    this.state = {
      selectedCategory: this.props.selectedJobCategory,
      disabled: this.props.disabled
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.jobCategories !== nextProps.jobCategories) {
      this.props.onSelectJobCategory(nextProps.jobCategories[0].name, nextProps.jobCategories[0].id)
    }
    if (this.state.disabled !== nextProps.disabled) {
      this.setState({
        disabled: nextProps.disabled
      })
    }
  }

  selectJobCategory = (e: React.MouseEvent<HTMLElement>) => {
    this.props.onSelectJobCategory(e.currentTarget.title, e.currentTarget.id)
    this.props.setJobCategoryName(e.currentTarget.title)
    this.props.onSetSelectedJobCategory(e.currentTarget.name)
    this.setState({
      selectedCategory: e.currentTarget.name
    })
  }

  setJobCategoryImage(name: string, index: number) {
    switch (name) {
      case JobCategoryNames.QUICK_HAUL:
        if (`${index}` === this.state.selectedCategory) {
          return images.quickHaulSelected
        }
        return images.quickHaul
      case JobCategoryNames.YARD_DEBRIS:
        if (`${index}` === this.state.selectedCategory) {
          return images.yardDebrisSelected
        }
        return images.yardDebris
      case JobCategoryNames.JUNK:
        if (`${index}` === this.state.selectedCategory) {
          return images.junkSelected
        }
        return images.junk
      case JobCategoryNames.RECYCLE:
        if (`${index}` === this.state.selectedCategory) {
          return images.recycleSelected
        }
        return images.recycle
    }
    return `${index}` === this.state.selectedCategory ? images.quickHaulSelected : images.quickHaul
  }

  render() {
    return (
      <div className="Pickup-info" >
        <div className="title">{StringResources.getString(Strings.Components.JobCategory.Title)}</div>
        <div className="category-list scrollable" >
          <PerfectScrollbar className="horizontal-scroll">
            {
              this.props.jobCategories.map((jobCategory, index) => (
                < Button
                  variant="contained"
                  classes={{
                    root: `${this.state.selectedCategory === `${index}` ? `button selected` : 'button'}`,
                    disabled: `${this.state.disabled ? 'button disabled' : 'button'}`
                  }}
                  title={jobCategory.name}
                  onClick={this.selectJobCategory}
                  key={jobCategory.id}
                  name={`${index}`}
                  id={jobCategory.id}
                  disabled={this.state.disabled}
                >
                  <img
                    src={this.setJobCategoryImage(jobCategory.name, index)}
                    alt=""
                    className="category-img"
                  />
                  <p>{jobCategory.name}</p>
                </Button>
              ))
            }
          </PerfectScrollbar>
        </div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/JobCategory.tsx